import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class ApiService {

  constructor(private http: HttpClient) {
  }

  public httpPost(apiAction: string, value?: FormData) {
    return this.http.post(apiAction, value);
  }
  public httpPostFromBody(apiAction: string, value?: object) {
    return this.http.post<any>(apiAction, value);
  }

  public httpPut(apiAction: string, value?: FormData) {
    return this.http.post<any>(apiAction, value);
  }
  public httpPutFromBody(apiAction: string, value?: object) {
    return this.http.post<any>(apiAction, value);
  }

  public httpGet(apiAction: string) {
    return this.http.get(apiAction);
  }

  public httpDelete(apiAction: string) {
    return this.http.delete(apiAction);
  }

}
